import { client } from '@/lib/api/client'
import { venueBusinessInfoChangeRequestsPath, venueBusinessInfoPath } from '@/lib/api/config'
import { toApiError } from '@/lib/api/errors'

import type { VenueBusinessInfoChangeRequestInput, VenueBusinessInfoView } from './venueBusinessInfoTypes'

/**
 * 사업자 정보 수정 요청 2EP(#1191, 백엔드 #1189 §D7-M1·M2).
 *
 * 🚨 서류 업로드 URL 발급·오브젝트 스토리지 직접 PUT은 **새로 만들지 않는다** — 백엔드 D5가 명시한 대로
 * pending key가 `{venueId}` 단위라 인증 회차와 무관하게 재사용 가능하다. 기존
 * `operationVerificationApi.ts`의 `requestOperationVerificationUploadUrl`/
 * `uploadOperationVerificationDocument`를 그대로 import해서 쓴다(호출부: `venueBusinessInfoViewModel`
 * 을 쓰는 페이지·`OperationVerificationDocumentField`).
 */

/** M2 — 현행 사업자 정보 + 대기중 요청 + 최근 반려 사유 조회. 게이팅 없이 항상 200. */
export async function fetchVenueBusinessInfo(venueId: string): Promise<VenueBusinessInfoView> {
  try {
    const { data } = await client.get<VenueBusinessInfoView>(venueBusinessInfoPath(venueId))
    return data
  } catch (error) {
    throw toApiError(error)
  }
}

/**
 * M1 — 사업자 정보 수정 요청 접수. 응답은 M2와 같은 shape(전환 후 상태) — 제출 직후 재조회하지 않고
 * 이 응답을 그대로 쓴다(`submitOperationVerification`과 같은 관례, Reader 복제 지연 회피).
 */
export async function submitVenueBusinessInfoChangeRequest(
  venueId: string,
  input: VenueBusinessInfoChangeRequestInput
): Promise<VenueBusinessInfoView> {
  try {
    const { data } = await client.post<VenueBusinessInfoView>(venueBusinessInfoChangeRequestsPath(venueId), input)
    return data
  } catch (error) {
    throw toApiError(error)
  }
}
